import { baseResources, baseResourceActions } from "routes/enum";

const {
    KB_SAM_ISSUE_CONVERSATION,
    KB_CONVERSATION_PIN,
    KB_CONVERSATION_LIBRARY,
} = baseResources;

const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

/** View conversation library */
export const CONVERSATION_LIBRARY_READ_PERMISSION = [
    `${READ}_${KB_CONVERSATION_LIBRARY}`,
];

/** Create new issues */
export const ISSUE_CONVERSATION_CREATE_PERMISSION = [
    `${CREATE}_${KB_SAM_ISSUE_CONVERSATION}`,
];

/** Edit conversation/workflow */
export const ISSUE_CONVERSATION_UPDATE_PERMISSION = [
    `${UPDATE}_${KB_SAM_ISSUE_CONVERSATION}`,
];

/** Pin conversation/workflow */
export const CONVERSATION_PIN_UPDATE_PERMISSION = [
    `${UPDATE}_${KB_CONVERSATION_PIN}`,
];

/** Delete conversation */
export const ISSUE_CONVERSATION_DELETE_PERMISSION = [
    `${DELETE}_${KB_SAM_ISSUE_CONVERSATION}`,
];

export const WORKFLOW_SETTINGS_PERMISSION_MAP = {
    "View conversation library": CONVERSATION_LIBRARY_READ_PERMISSION,
    "Create new issues": ISSUE_CONVERSATION_CREATE_PERMISSION,
    "Edit conversation/workflow": ISSUE_CONVERSATION_UPDATE_PERMISSION,
    "Pin conversation/workflow": CONVERSATION_PIN_UPDATE_PERMISSION,
    "Delete conversation": ISSUE_CONVERSATION_DELETE_PERMISSION,
};
